import { render, staticRenderFns } from "./form-view.vue?vue&type=template&id=236e8a64&"
import script from "./form-view.vue?vue&type=script&lang=ts&"
export * from "./form-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236e8a64')) {
      api.createRecord('236e8a64', component.options)
    } else {
      api.reload('236e8a64', component.options)
    }
    module.hot.accept("./form-view.vue?vue&type=template&id=236e8a64&", function () {
      api.rerender('236e8a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form-view.vue"
export default component.exports